import { TourContext, TourGateState, TourRegistration } from '../types';
import { isEligibleOnRoute } from './route';
import { deriveStatus } from './status';

/**
 * Should this tour be started right now? Pure so the refresh behaviour is testable.
 *
 * The `notStarted` check is what stops a page refresh from wiping progress: rehydrated state
 * already has a stepHistory, so the tour reads as active and is skipped here. (Render is also
 * gated behind PersistGate, so this never runs against pre-hydration state.)
 *
 * Progress comes from `gate.tours` — the merged view — so a tour completed on another device
 * is not restarted here before the local history catches up.
 *
 * An `isEligible` answering `pending` does NOT start the tour. Starting stamps `startedAt` and
 * emits a 'triggered' event, neither of which can be taken back if the answer settles on false.
 * Waiting costs a re-render; guessing costs a bogus tour run in the analytics.
 */
export const shouldAutoStart = (
  tour: TourRegistration,
  gate: TourGateState,
  pathname: string,
  ctx?: TourContext,
): boolean => {
  if (tour.isEligible && tour.isEligible(gate, ctx, pathname) !== true) return false;
  if (!isEligibleOnRoute(tour.scope, pathname)) return false;
  if (deriveStatus(gate.tours[tour.id]) !== 'notStarted') return false;
  return Boolean(tour.autoStart?.(gate, pathname));
};

export default shouldAutoStart;
